import { useConfigHelper } from '@ilteducation/config';
import type { RegisterEventsBody } from '@ilteducation/activity-stream-types';
import axios from 'axios';

const { getApiUrl } = useConfigHelper();

export const sendEventToActivityStream = async (data: RegisterEventsBody) => {
  const hostname = window.location.hostname;
  const hostnameWithoutDots = hostname.replace(/\./g, '');

  await axios.post(`${getApiUrl('activity-stream')}/origin/${hostnameWithoutDots}/events`, data, {
    adapter: 'fetch',
    fetchOptions: {
      keepalive: true,
    },
  });
};
